import { IntrospectionFragmentMatcher } from 'apollo-client';

import ResourceTypes from 'legacy/packages/unit-outline/src/constants';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: 'INTERFACE',
          name: 'Resource',
          possibleTypes: Object.values(ResourceTypes).map((typeName) => ({
            name: typeName,
          })),
        },
      ],
    },
  },
});

export default fragmentMatcher;
